// Browser fallback used before the server-provided product name is available.
//
// The value is the brand compiled into this build rather than a second literal, which mirrors the
// Go seam exactly: internal/foundation/branding holds one ProductName constant that is also the
// default for Config.ProductName when VENUEOPS_PRODUCT_NAME is unset. Here the constant lives
// with the artwork it names, so the word beside the mark and the word inside the mark's title
// cannot drift apart.
//
// A deployment may still show something else. The API root returns the configured name and the
// browser prefers that once it arrives; this is only what is drawn before anybody has answered.
// The other places the brand is written down are web/index.html, the Worker's PRODUCT_NAME
// variable in edge/api/wrangler.jsonc, and VENUEOPS_PRODUCT_NAME wherever it is configured.
// docs/23-brand-identity.md is the checklist.
import { brandName } from "./brand/mark";

export const PRODUCT_NAME = brandName;
